import styled, { css } from 'styled-components'

export const STATE_DOT_SIZE = 6
export const PREVIEW_SIZE = 40

export const Root = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px 14px 18px;
  border-radius: 10px;
  cursor: pointer;
  position: relative;

  color: ${({ theme }) => theme.colors.foreground.secondary.A};

  &:hover,
  &:focus-within {
    background: ${({ theme }) => theme.colors.background.tertiary.D};
  }

  .active & {
    background: ${({ theme }) => theme.colors.sketch.F};
    color: ${({ theme }) => theme.colors.sketch.A};
  }
`

export const StateDot = styled.span<{ $visible: boolean }>`
  width: ${STATE_DOT_SIZE}px;
  height: ${STATE_DOT_SIZE}px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.sketch.A};
  flex-shrink: 0;
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  position: absolute;

  inset: auto auto auto 7px;
`

export const PreviewWrapper = styled.div`
  position: relative;
  width: ${PREVIEW_SIZE}px;
  height: ${PREVIEW_SIZE}px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const TypeIconOverlay = styled.span`
  position: absolute;
  right: -4px;
  bottom: -4px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`

export const Title = styled.div`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 14px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Subtitle = styled.div`
  font-size: 13px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.55;
`

export const Meta = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-left: 12px;
  position: relative;
`

const swap = css`
  transition: opacity 120ms ease;
`

export const Timeago = styled.span`
  ${swap};

  opacity: 0.25;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.fontWeights.regular};

  /* ${Root}:hover &,
  ${Root}:focus-within & {
    opacity: 0;
    pointer-events: none;
  } */
`

export const Actions = styled.div`
  ${swap};
  display: flex;
  align-items: center;
  gap: 4px;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);

  /* ${Root}:hover &,
  ${Root}:focus-within & {
    opacity: 1;
    pointer-events: auto;
  } */
`

export const ActionButton = styled.button`
  appearance: none;
  border: 0;
  background: ${({ theme }) => theme.colors.background.secondary.A};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary.B};
    color: ${({ theme }) => theme.colors.foreground.primary.A};
  }

  > svg {
    width: 14px;
    height: 14px;
  }
`
